<template>
    <div class="abouts">
        <h1 class="abouts__box-header__title">{{ getTranslatedText('Fafi number dream guide') }}</h1>
        <div class="abouts__list">
            <details class="abouts__item" v-for="(v, i) in listAbouts" :key="i">
                <summary>
                    {{
                        getTranslatedText('Fafi Numbers [number]', {
                            number: renderTitleSummary(v, i),
                        })
                    }}
                </summary>
                <div class="abouts__item-content">
                    <div class="abouts__item-items" v-for="(item, index) in v" :key="index">
                        <div class="abouts__item-items-content">
                            <b>{{ item.number }}.</b> {{ item.title }}
                        </div>
                    </div>
                </div>
            </details>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import themeMixins from '@/mixins/pathAssets/path-assets-mixins'
import { renderNameGame } from '@/utils/utils'

export default {
    mixins: [languageMixins, themeMixins],
    props: {
        listAbouts: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        renderTitleSummary(v, i) {
            const startIndex = i * 10 + 1
            const endIndex = Math.min((i + 1) * 10, this.$store.state.gameLength)
            return `${startIndex}-${endIndex}`
        },

        renderName(number) {
            return renderNameGame(parseInt(number))
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/abouts/index.scss';
</style>
